<template>
  <div class="fater-lab">
    <div style="margin: 15px 0;">
      <el-input
        placeholder="请输入搜索内容"
        v-model="form.name"
        class="input-with-select"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="search"
        ></el-button>
      </el-input>
    </div>
    <div class="content">
      <div
        class="li"
        v-for="item in List"
        :key="item.name"
      >
        <div>
          <img
            :src="url+item.imgUrl"
            alt=""
          >
          <div class="span">
            {{item.name}}
          </div>
        </div>
        <div class="yincang">
          <el-button
            type="primary"
            size="mini"
            @click="ok(item)"
          >点击上传</el-button>
        </div>
      </div>
      <div
        class="gengduo"
        v-show="isGengduo"
      >
        <el-button
          type="primary"
          size="mini"
          :loading="gengduo"
          @click="more"
        >{{gengduo?"加载中":'更多图片'}}</el-button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  created() {
    this.load();
  },
  data() {
    return {
      isGengduo: false,
      gengduo: false,
      url: "",
      List: [],
      form: {
        name: "",
        pageNum: 1,
        pageSize: 10
      }
    };
  },
  methods: {
    ok(item) {
      this.$emit("initImg", {
        imgUrl: item.imgUrl,
        url: this.url + item.imgUrl
      });
      this.$emit("close");
    },
    more() {
      this.form.pageNum++;
      this.gengduo = true;
      this.load().then(r => {
        this.gengduo = false;
      });
    },
    search() {
      this.form.pageNum = 1;
      this.load();
      this.List = [];
    },
    load() {
      return this.$http
        .post("/api/file/baseGoods/base", this.form)
        .then(res => {
          this.List = [...this.List, ...res.data.list];
          if (res.data.list.length < this.form.pageSize) {
            this.isGengduo = false;
          } else {
            this.isGengduo = true;
          }
          this.url = res.data.picUrlPath;
        });
    }
  }
};
</script>

<style scoped>
.gengduo {
  clear: both;
  width: 100%;
  margin-top: 15px;
  padding: 10px 0;
  border-top: 1px dashed #e2e2e2;
  text-align: center;
}
.fater-lab {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: auto;
}
.content {
  flex: 1;
  list-style: none;
  position: relative;
  margin-bottom: 10px;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
}
.content .li {
  float: left;
  width: 20%;
  height: 177px;
  text-align: center;
  margin: 10px 0;
  position: relative;
}
.yincang {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.3);
  transition: all 0.2s;
}
.content .li:hover .yincang {
  opacity: 1;
}

.content .li > div {
  width: 150px;
  margin: 0 auto;
  box-shadow: 2px 4px 12px 0 #8b8989;
}
.content img {
  width: 150px;
  height: 150px;
}
.content .li div .span {
  padding: 3px 0;
}
</style>


// WEBPACK FOOTER //
// src/view/page/commodityAdmin/serverImg.vue